import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "search", "list", "row", "checkbox", "count", "submit", "noResults"]

  connect() {
    this.boundKeyHandler = this.handleKeydown.bind(this)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeyHandler)
    document.body.style.overflow = ""
  }

  open(event) {
    if (event) event.preventDefault()
    if (!this.hasModalTarget) return
    this.modalTarget.classList.add("is-open")
    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this.boundKeyHandler)
    if (this.hasSearchTarget) {
      setTimeout(() => this.searchTarget.focus(), 100)
    }
  }

  close(event) {
    if (event) event.preventDefault()
    if (!this.hasModalTarget) return
    this.modalTarget.classList.remove("is-open")
    document.body.style.overflow = ""
    document.removeEventListener("keydown", this.boundKeyHandler)
  }

  closeOnOverlay(event) {
    if (event.target === event.currentTarget) {
      this.close()
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  filter() {
    const query = this.searchTarget.value.trim().toLowerCase()
    let visibleCount = 0
    this.rowTargets.forEach(row => {
      const text = row.dataset.searchText || ""
      const matches = query === "" || text.includes(query)
      row.hidden = !matches
      if (matches) visibleCount++
    })
    if (this.hasNoResultsTarget) {
      this.noResultsTarget.hidden = visibleCount > 0
    }
  }

  selectAllVisible() {
    this.rowTargets.forEach(row => {
      if (row.hidden) return
      const checkbox = row.querySelector("input[type=checkbox]")
      if (checkbox) checkbox.checked = true
    })
    this.updateCount()
  }

  clearAll() {
    this.checkboxTargets.forEach(c => { c.checked = false })
    this.updateCount()
  }

  updateCount() {
    const selected = this.checkboxTargets.filter(c => c.checked).length
    if (this.hasCountTarget) {
      this.countTarget.textContent = `${selected} selected`
    }
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = selected === 0
    }
  }
}
